import React from 'react'
import StReferral from './static/StReferral';
import ChReferral from './change/ChReferral';



const Referrals = (props) => {
	const { availableCodeCount, data, email, visitorId} = props;
	return (
		<div className="panel-card-container referrals-explainer-card-container">
			{
				availableCodeCount > -1 ?
				<ChReferral data = { data } email={email} visitorId={visitorId}/>
				:
				<StReferral />
			}
		</div>

	)
}

export default Referrals;